// extracted by mini-css-extract-plugin
export default {"buttons":"styles_buttons__pQRNb","gap":"styles_gap__x-n6T","removeIcon":"styles_removeIcon__DzN89","createButton":"styles_createButton__RT1lL"};